// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'primary', 'primary Fallback'"},"className":"__className_d4f5d6","variable":"__variable_d4f5d6"};